/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_CloseInputs */

const en_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const de_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schliessen`)
};

const fr_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const es_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const it_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const nl_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const pl_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const fi_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje`)
};

const da_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

const sv_cancel_close = /** @type {(inputs: Cancel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Cancel_CloseInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_close = /** @type {((inputs?: Cancel_CloseInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_CloseInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_close(inputs)
	if (locale === "fr") return fr_cancel_close(inputs)
	if (locale === "es") return es_cancel_close(inputs)
	if (locale === "it") return it_cancel_close(inputs)
	if (locale === "nl") return nl_cancel_close(inputs)
	if (locale === "pl") return pl_cancel_close(inputs)
	if (locale === "fi") return fi_cancel_close(inputs)
	if (locale === "da") return da_cancel_close(inputs)
	if (locale === "sv") return sv_cancel_close(inputs)
	return en_cancel_close(inputs)
});